import React, { useContext, useEffect, memo } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AuthContext } from './AuthContext';
import { getLoginUrl } from './authentication';
import { getLastSegmentFromPath } from '../utils';
import BaseRoute from '../BaseRoute';

const PrivateRoute = ({ component: Component, ...otherProps }) => {
    const { checkIsAuthenticated } = useContext(AuthContext);
    const location = useLocation();

    const Login = () => {
        useEffect(() => {
            (async () => {
                console.log('login');
                const loginUrl = await getLoginUrl();
                const routeName = getLastSegmentFromPath(location.pathname);
                localStorage.setItem('redirectTo', routeName);
                localStorage.setItem('redirectUrl', location.pathname);
                // The next line redirects to MyAccount and THIS APP DIES.
                // Once MyAccount has finished authenticating the user, this app gets rebooted.
                // To redirect the user to the original page they were trying to
                // get to, we save it to local storage before calling the next line.
                window.location.href = loginUrl;
            })();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        return <></>;
    };

    return (
        <BaseRoute
            { ...otherProps }
            render={ props => (
                checkIsAuthenticated()
                    ?
                    <Component { ...props } />
                    :
                    <Login />
            ) }
        />
    );
};

PrivateRoute.propTypes = {
    component: PropTypes.func.isRequired
};

export default memo(PrivateRoute);
